import styled from '@emotion/styled'

import { SUB_COLOR } from '@/constants/colors'

const BADGE_BG_COLOR = '#ffd766'
const BADGE_TEXT_COLOR = '#1b1c1d'

export const Container = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  width: 100%;
  padding-right: 8px;
`

export const ProductImage = styled.img`
  width: 88px;
  height: 88px;
  flex-shrink: 0;
  object-fit: contain;
  background-color: #fff;
  padding: 10.5px;
  border-radius: 30px;
`

export const InfoWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`

export const Row = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
`

export const JackpotLabel = styled.span`
  color: ${BADGE_BG_COLOR};
  font-size: 14px;
  font-weight: 600;
  line-height: 18px;
`

export const Badge = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  width: fit-content;
  padding: 4px 8px;
  background-color: ${BADGE_BG_COLOR};
  border-radius: 16px;
  font-size: 14px;
  font-weight: 700;
  line-height: 18px;
  letter-spacing: 0.06px;
  color: ${BADGE_TEXT_COLOR};
`

export const ProductName = styled.span`
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
  letter-spacing: -0.08px;
  color: white;
`

export const ProductDescription = styled.span`
  font-size: 12px;
  font-weight: 500;
  line-height: 16px;
  letter-spacing: 0.06px;
  color: ${SUB_COLOR};
`
